module.exports = __webpack_public_path__ + "static/media/jelkeschippers.1c2a0a26.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jelkeschippers.webp
// module id = 715
// module chunks = 0